import { DEFAULT_ACCOUNT_ID } from "../lib/storage";
import type { LifeOsCollectionName, LifeOsState, SyncState } from "../types";

const DEFAULT_ACCOUNT_NAME = "Ví mặc định";

const userVisibleCollections: Exclude<LifeOsCollectionName, "accounts">[] = [
  "tasks",
  "projects",
  "goals",
  "habits",
  "notes",
  "transactions",
  "budgets",
  "inbox",
  "events",
  "recurring",
  "dailyPlans",
  "dailyReviews",
  "weeklyReviews",
  "templates",
  "currencyRates",
  "financeCategories",
];

function isEmptyDefaultAccount(account: LifeOsState["accounts"][number]) {
  return (
    account.id === DEFAULT_ACCOUNT_ID &&
    account.name === DEFAULT_ACCOUNT_NAME &&
    account.type === "cash" &&
    account.openingBalance === 0 &&
    account.currency === "VND"
  );
}

export function hasUserVisibleState(state: LifeOsState) {
  return (
    userVisibleCollections.some((name) => state[name].length > 0) ||
    state.accounts.some((account) => !isEmptyDefaultAccount(account)) ||
    state.dirtyItems.length > 0 ||
    state.deletedItems.length > 0
  );
}

export function shouldShowFirstSyncSkeleton(state: LifeOsState, syncState: SyncState, hasUser: boolean) {
  return syncState === "connecting" && hasUser && !hasUserVisibleState(state);
}
